import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import type { Ref } from 'vue'
import { useSubmit } from './FormMixin' 
import { getTrialAccess } from '@/services/access.service'
import executeWithRefresh from '@/composables/useRefresher'
import MailChecker from 'mailchecker'
import useGlobal from '../../composables/useGlobal'

import {
  getCookie,
  setCookie,
} from '@/utils/cookies'

import {
  HQ_USER_SAVED_NAME,
  HQ_REFERENCE_COOKIE_NAME,
} from '@/const'


export default /*#__PURE__*/_defineComponent({
  __name: 'TestAccessForm',
  props: ['subscriptionLink'],
  setup(__props, { expose }) {
  expose();

const props = __props

const { $t } = useGlobal()

const isLoad: Ref<boolean> = ref(false)
const alreadyUsed = ref('')
const emailError = ref($t('Не подходящий email'))
let mailSended = ref(false)
let mailError = ref(false)
let mailErrorText = ref(false)
let email = ref("")
let code = ref("")

const request = (sendData: any, control: any) => {
  if(MailChecker.isValid(email.value)) {
    useSubmit(send(sendData, control), control)
    isLoad.value = true
  } else {
    control.setFieldError('owner', emailError.value)
  }
}

function startTimer() {
  mailSended.value = true
}

const formatter = str => {
  return String(str).length > 1 ? str : `0${str}`
}

const send = async (sendData, control) => {
  const prependedData = {
    ...sendData,
    ref_id: getCookie(HQ_REFERENCE_COOKIE_NAME),
  }
  try {
    const { data: { access, refresh } } = (await executeWithRefresh(getTrialAccess, null, {type: 'trial'}, prependedData))
    mailSended.value = true
   
  } catch(e) {
     e.json().then(body => {
        control.setFieldError('owner', body.errors[0].state.owner[0].message)
        if (400 == body.code) {
          alreadyUsed.value = body.errors[0].state.owner[0].message
        } else {
          isLoad.value = false
          mailError.value = true
        } 
      })
    return Promise.reject(e)
  }
}

  
const __returned__ = { $t, props, isLoad, alreadyUsed, emailError, mailSended, mailError, mailErrorText, email, code, request, startTimer, formatter, send, ref, useSubmit, getTrialAccess, executeWithRefresh, MailChecker, useGlobal, getCookie, setCookie, HQ_USER_SAVED_NAME, HQ_REFERENCE_COOKIE_NAME }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})